<template lang="pug">
section#user-image-gallery.slide.p-text(v-if="galleries.length")
  .title.mb40.mt40
    subtitle(text="画像ギャラリー")
  .swiper-base-wrapper
    swiper(
      :modules="modules"
      :slides-per-view="swiperOptions.slidesPerView"
      :space-between="swiperOptions.spaceBetween"
      :navigation="swiperOptions.navigation"
      :scrollbar="swiperOptions.scrollbar"
      :breakpoints="swiperOptions.breakpoints"
    )
      swiper-slide(v-for="gallery in galleries")
        div(@click="openPopup(gallery.originalPicName)")
          img.slide-img.js-no-image(:src="gallery.picName" alt="")
    button.user-image-gallery-swiper-button.swiper-button-prev
    button.user-image-gallery-swiper-button.swiper-button-next
    .swiper-gallery-scrollbar(slot="scrollbar")
  image-popup(v-if="popup.show" :src="popup.src" @close="closePopup")
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import Subtitle from "~/components/Common/Subtitle.vue";
import { Swiper, SwiperSlide } from "swiper/swiper-vue.mjs";
import { Navigation, Scrollbar } from "swiper/modules";
import "swiper/swiper-bundle.css";
import UserAccountRepository from "~/repositories/UserAccountRepository";
import ImageGalleryModel from "~/models/ImageGalleryModel";
import ImagePopup from "~/components/Common/ImagePopup";

export default defineComponent({
  name: "UserImageGallery",
  components: {
    ImagePopup,
    Swiper,
    SwiperSlide,
    Subtitle
  },
  props: {
    userIdHash: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const swiperOptions = {
      slidesPerView: 2,
      spaceBetween: 30,
      allowTouchMove: true,
      navigation: {
        nextEl: ".user-image-gallery-swiper-button.swiper-button-next",
        prevEl: ".user-image-gallery-swiper-button.swiper-button-prev"
      },
      scrollbar: {
        el: ".swiper-gallery-scrollbar",
        draggable: true
      },
      breakpoints: {
        850: {
          slidesPerView: 4,
          spaceBetween: 40,
          allowTouchMove: false,
        }
      }
    };

    const galleries = ref<Array<ImageGalleryModel>>([]);
    const getGalleries = async () => {
      try {
        const repo = new UserAccountRepository();
        galleries.value = await repo.imageGalleries(props.userIdHash);
      } catch (e) {
        alert("画像ギャラリーの取得に失敗しました。時間を置いて再度お試しください。");
        console.log(e);
      }
    };

    const popup = reactive({
      show: false,
      src: ""
    });
    const openPopup = (src) => {
      popup.src = src;
      popup.show = true;
    };
    const closePopup = () => {
      popup.src = "";
      popup.show = false;
    };

    onMounted(async () => {
      await getGalleries();
    });

    return {
      swiperOptions,
      galleries,
      openPopup,
      closePopup,
      popup,
      modules: [Navigation, Scrollbar]
    };
  }
});
</script>

<style scoped lang="scss">
.slide {
  margin-bottom: 71px;
}

.swiper-container {
  height: 170px;

  @media screen and (max-width: 850px) {
    height: 100px;
  }
}

.swiper-base-wrapper {
  position: relative;
}

.swiper-pagination-bullet {
  display: none;
}

.swiper-gallery-scrollbar-drag {
  height: 100%;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  bottom: 50px;
}

.swiper-gallery-scrollbar {
  height: 5px;
}

.swiper-wrapper {
  padding: 0;
  overflow-x: scroll;
}

.swiper {
  width: 100%;
}

.swiper2 {
  position: relative;
  width: 100%;
  height: 200px;
}

.slide li:hover,
.any-company-list:hover {
  opacity: 0.8;
}

.swiper-button-prev,
.swiper-button-next {
  border-radius: 40px;
  background-color: #191919;
  color: white;
  padding: 30px;
  text-align: center;
  width: 10px;
  height: 10px;
  border: none;

  @media screen and (max-width: 850px) {
    display: none;
  }
}

.swiper-button-next {
  right: 10px;
  left: auto;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 20px;
}

.slide-img {
  width: 100%;
  height: 168px;
  object-fit: contain;

  @media screen and (max-width: 850px) {
    height: 84px;
  }
}

.slide-title {
  font-size: 12px;
  color: #00b900;
  margin-top: 12px;
  margin-bottom: 10px;
}

.slide-txt {
  margin-top: 5px;
  font-weight: normal;
  font-size: 16px;

  @media screen and (max-width: 850px) {
    font-size: 10px;
  }
}
</style>
